import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { clearSiteStore } from 'reducers/site/reducer'
import SiteItem from './SiteItem'
import SiteList from './SiteList'

function Site(props) {
  const {
    match: {
      params: { id },
    },
    clearSiteStore,
  } = props
  const SiteContent = id ? SiteItem : SiteList

  useEffect(
    () => () => {
      clearSiteStore()
    },
    [],
  )

  return (
    <div className="content">
      <SiteContent {...props} />
    </div>
  )
}

Site.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  clearSiteStore: PropTypes.func.isRequired,
}

export default connect(null, {
  clearSiteStore,
})(Site)
